import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import loginLogo from "../assets/Img/loginLogo.png";

const Login = () => {
  const [pin, setPin] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = (event) => {
    event.preventDefault();

    const correctPin1 = "112024"; // Admin
    const correctPin2 = "112244"; // Stock

    const expiryTime = Date.now() + 12 * 60 * 60 * 1000;
    if (pin === correctPin1) {
      sessionStorage.setItem(
        "auth",
        JSON.stringify({ loggedIn: true, expiryTime })
      );
      navigate("/wip-dashboard");
    } else if (pin === correctPin2) {
      sessionStorage.setItem(
        "auth",
        JSON.stringify({ loggedIn: true, expiryTime })
      );
      navigate("/Stock");
    } else {
      setErrorMessage("Incorrect PIN. Try again.");
    }
  };

  const handleRedirect = () => {
    navigate("/"); // Redirect to main login
  };

  // Styles
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    position: "relative",
    background: "#ffffff", // Pure white background
    overflow: "hidden",
    fontFamily: "Poppins, sans-serif",
  };

  const cardStyle = {
    backgroundColor: "#fff",
    padding: "40px 30px",
    borderRadius: "16px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "100%",
    maxWidth: "400px",
    zIndex: 1,
    animation: "fadeIn 0.8s ease",
  };

  const inputStyle = {
    padding: "12px",
    marginBottom: "16px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    width: "100%",
    outline: "none",
    fontSize: "14px",
    transition: "all 0.25s ease",
  };

  const buttonStyle = {
    width: "100%",
    padding: "12px",
    border: "none",
    borderRadius: "8px",
    background: "linear-gradient(135deg,#2193b0,#6dd5ed)",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
  };

  const buttonHover = {
    transform: "translateY(-2px) scale(1.02)",
    boxShadow: "0 8px 15px rgba(0,0,0,0.1)",
  };

  const errorStyle = {
    color: "#ff4d4f",
    marginTop: "10px",
    fontSize: "14px",
  };

  const logoStyle = {
    height: "60px",
    width: "60px",
    marginBottom: "15px",
    borderRadius: "50%",
    animation: "logoPop 1s ease",
  };

  return (
    <div style={containerStyle}>
      <button
        className="btn btn-secondary btn-sm"
        style={{ position: "absolute", top: "10px", right: "10px" }}
        onClick={handleRedirect}
      >
        ← WIP
      </button>

      <div style={cardStyle}>
        <img src={loginLogo} alt="Logo" style={logoStyle} />
        <h2>Enter PIN to Access</h2>
        <form onSubmit={handleLogin}>
          <input
            type="password"
            placeholder="Enter PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            required
            style={inputStyle}
          />
          <button
            type="submit"
            style={buttonStyle}
            onMouseEnter={(e) =>
              Object.assign(e.target.style, buttonHover)
            }
            onMouseLeave={(e) =>
              Object.assign(e.target.style, buttonStyle)
            }
          >
            Login
          </button>
          {errorMessage && <p style={errorStyle}>{errorMessage}</p>}
        </form>
      </div>

      {/* Optional subtle floating circles */}
      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(33,147,176,0.05)",
          top: "-50px",
          left: "-50px",
          animation: "float 10s infinite ease-in-out",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background: "rgba(33,147,176,0.05)",
          bottom: "-100px",
          right: "-100px",
          animation: "float 12s infinite ease-in-out",
        }}
      ></div>

      {/* Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity:0; transform:translateY(20px); }
          to { opacity:1; transform:translateY(0); }
        }
        @keyframes logoPop {
          0% { transform: scale(0.7); opacity:0; }
          100% { transform: scale(1); opacity:1; }
        }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(20px); }
          100% { transform: translateY(0px); }
        }
      `}</style>
    </div>
  );
};

export default Login;